<template>
  <div>
    <section class="hero is-danger">
      <h3 class="is-size-3">ユーザー設定</h3>
    </section>
    <section class="section">
      <div class="container">
        <div class="hero">
          <div class="field">
            <button class="button is-danger is-size-5 is-rounded" @click="openModal">ユーザー新規追加</button>
          </div>
        </div>
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>ログインID</th>
              <th>乗務員名</th>
              <th>最終ログイン日時</th>
              <th>操作</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in getItems" v-bind:key="item.id">
              <th>{{ item.login_id }}</th>
              <td>{{ item.username }}</td>
              <td>{{ item.lastlogin_at }}</td>
              <td>
                <button class="button is-link is-rounded" @click.prevent="editButtonClick(item)">編集</button>
              </td>
              <td>
                <button
                  class="button is-danger is-rounded"
                  @click.prevent="deleteButtonClick(item)"
                >削除</button>
              </td>
            </tr>
          </tbody>
        </table>
        <nav class="pagination is-centered" role="navigation" aria-label="pagination">
          <paginate
            v-model="page.currentPage"
            :page-count="getPageCount"
            :page-range="3"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'前'"
            :next-text="'次'"
            :container-class="'pagination-list'"
            :page-link-class="'pagination-link'"
            :page-class="''"
            :hide-prev-next="true"
            :prev-link-class="'pagination-previous'"
            :next-link-class="'pagination-next'"
            :active-class="'pagination-link is-current'"
            :no-li-surround="true"
          ></paginate>
        </nav>
      </div>
    </section>
    <section class="section">
      <div class="hero">
        <div class="field">
          <button class="button is-link is-size-5 is-rounded" @click="$router.go(-1)">戻る</button>
        </div>
      </div>
    </section>
    <!-- モーダル表示 -->
    <div class="modal" v-bind:class="{'is-active': isModal}">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ modal.title }}</p>
          <button class="delete" aria-label="close" @click="close_popup"></button>
        </header>
        <form @submit.prevent="submit">
          <section class="modal-card-body">
            <div v-if="isErrors">
              <p class="has-text-danger">{{ isErrors }}</p>
            </div>
            <div class="field">
              <label for class="label">乗務員名</label>
              <div class="control has-icons-left">
                <input
                  type="text"
                  placeholder="乗務員名"
                  class="input"
                  v-model="inputForm.username"
                  required
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-user-friends"></i>
                </span>
              </div>
            </div>
            <div class="field">
              <label for class="label">ログインID</label>
              <div class="control has-icons-left">
                <input
                  type="text"
                  placeholder="ログインID"
                  class="input"
                  v-model="inputForm.login_id"
                  required
                  v-bind:disabled="modal.login_id"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-user-friends"></i>
                </span>
              </div>
            </div>
            <div
              class="h7 is-size-7 has-text-danger"
              v-show="error.login_id"
            >※ログインIDで使用できるものは半角英数字3文字以上15文字以内です</div>
            <div class="field">
              <label for class="label">パスワード</label>
              <div class="control has-icons-left">
                <input
                  type="password"
                  placeholder="*******"
                  class="input"
                  v-model="inputForm.password"
                  required
                  v-bind:disabled="!modal.password"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-lock"></i>
                </span>
              </div>
              <div v-if="!modal.password">
                <label class="checkbox">
                  <input type="checkbox" v-model="modal.password" />
                  パスワードを変更する
                </label>
              </div>
            </div>
            <div
              class="h7 is-size-7 has-text-danger"
              v-show="error.password"
            >※パスワードは最低{{ passLen }}文字以上を設定してください</div>
          </section>
          <footer class="modal-card-foot">
            <button
              type="submit"
              class="button is-success"
              v-bind:class="{'is-loading':disabled, '':isErrors}"
            >保存</button>
            <button class="button" @click="close_popup" v-bind:class="{'is-loading':disabled}">キャンセル</button>
          </footer>
        </form>
      </div>
    </div>
    <!-- モーダル表示 end -->
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";
import { mapState, mapActions } from "vuex"; //Vuex が提供する mapState 関数を使う
const CREATE = "create";
const EDIT = "edit";

export default {
  data: function () {
    return {
      isModal: false,
      passLen: 4,
      inputForm: {
        username: "",
        login_id: "",
        password: "",
      },
      error: {
        login_id: null,
        password: null,
      },
      page: {
        parPage: 10,
        currentPage: 1,
      },
      disabled: false,
      modal: {
        title: "ユーザー新規追加",
        alert: "ユーザーを登録しました",
        mode: "",
        login_id: false,
        password: false,
      },
    };
  },
  components: {
    paginate: Paginate, //https://www.kabanoki.net/4320/
  },
  computed: {
    ...mapState({
      items: (state) => state.users.users,
      getItems(state) {
        //mapStateの中でthisを使う際にはアローはNG
        this.page.currentPage = state.status.userCurrentPage;
        let current = state.status.userCurrentPage * this.page.parPage;
        let start = current - this.page.parPage;
        return this.items.slice(start, current);
      },
      apiStatus: (state) => state.users.apiStatus,
      isErrors(state) {
        if (state.users.errorMessages) {
          this.disabled = false;
        }
        return state.users.errorMessages;
      },
      // isErrors: state => state.users.errorMessages,
    }),
    getPageCount: function () {
      return Math.ceil(this.items.length / this.page.parPage);
    },
  },
  mounted() {
    this.$store.dispatch("users/getUsers");
  },
  methods: {
    ...mapActions({
      setUserCurrentPage: "status/setUserCurrentPage",
    }),
    clearError() {
      this.$store.commit("users/setErrorMessages", null);
      Object.keys(this.error).forEach((key) => {
        this.$set(this.error, key, null);
      });
    },
    clearFrom() {
      //初期化
      Object.keys(this.inputForm).forEach((key) => {
        this.$set(this.inputForm, key, null);
      });
    },
    async submit() {
      this.clearError();
      if (!this.isValidation()) return false;
      this.disabled = true; //ボタンをローディング表示にする
      if (this.modal.mode == CREATE) {
        await this.$store.dispatch("users/createUser", this.inputForm);
      } else if (this.modal.mode == EDIT) {
        await this.$store.dispatch("users/editUser", this.inputForm);
      }
      if (this.apiStatus) {
        window.alert(this.modal.alert);
        //ページリロード
        this.reset();
      }
    },
    isValidation() {
      //ログインIDのバリデーション
      const pattern = /^[a-zA-Z0-9_\-.]{3,15}$/g;
      if (this.inputForm.login_id.match(pattern) == null) {
        this.error.login_id = true;
        return false;
      }
      if (
        this.modal.password ||
        (this.modal.password && this.modal.mode === EDIT)
      ) {
        //パスワードのバリデーション
        if (this.inputForm.password.length < this.passLen) {
          this.error.password = true;
          return false;
        }
      }
      return true;
    },
    reset() {
      this.$router.go({ path: this.$router.currentRoute.path, force: true });
    },
    openModal() {
      //初期化
      this.clearFrom();
      this.clearError();
      this.modal.mode = CREATE;
      this.modal.title = "ユーザー新規追加";
      this.modal.alert = "ユーザーを登録しました";
      this.modal.login_id = false;
      this.modal.password = true;
      this.isModal = true;
    },
    close_popup() {
      //初期化
      this.clearFrom();
      this.clearError();
      this.isModal = false;
    },
    clickCallback: function (pageNum) {
      this.setUserCurrentPage(Number(pageNum));
    },
    editButtonClick(item) {
      //初期化
      this.clearFrom();
      this.clearError();
      this.modal.mode = EDIT;
      this.modal.title = "ユーザー情報の編集";
      this.modal.alert = "ユーザー情報を変更しました";
      this.modal.login_id = true;
      this.modal.password = false;
      this.inputForm.username = item.username;
      this.inputForm.login_id = item.login_id;
      this.inputForm.password = item.password;
      this.isModal = true;
    },
    async deleteButtonClick(item) {
      if (
        window.confirm(
          "選択したユーザーを削除してよろしいですか？削除したユーザーは戻せません。"
        )
      ) {
        this.inputForm.username = item.username;
        this.inputForm.login_id = item.login_id;
        this.inputForm.password = item.password;

        await this.$store.dispatch("users/deleteUser", this.inputForm);

        if (this.apiStatus) {
          window.alert("ユーザーを削除しました。");
          //ページリロード
          this.reset();
        }
      }
    },
  },
};
</script>

<style scoped>
.hero {
  text-align: center;
}
</style>
